import { render, staticRenderFns } from "./SpatialSpanSequenceTutorial.vue?vue&type=template&id=a6cb894c&scoped=true&"
import script from "./SpatialSpanSequenceTutorial.vue?vue&type=script&lang=js&"
export * from "./SpatialSpanSequenceTutorial.vue?vue&type=script&lang=js&"
import style0 from "./SpatialSpanSequenceTutorial.vue?vue&type=style&index=0&id=a6cb894c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cb894c",
  null
  
)

export default component.exports